import React from 'react';
import BaseModal from '../../common/ModalWindows/BaseModal';
import { useWindowSize } from '../../../utils/hooks';
import { MOBILE_BREAKPOINT } from '../../../utils/constants';
import colors from '../../../scss/colors';

function BasicForm(props) {
  const { children, cancel, blue } = props;
  const size = useWindowSize();

  return (
    <BaseModal
      open
      fullscreen={size.width < MOBILE_BREAKPOINT}
      closeHandler={cancel}
      confirmHandler={() => {}}
      title=""
      onlyConfirm
      onlyReject
      hideHeader
      hideFooter
      container={size.width < MOBILE_BREAKPOINT ? () => document.getElementById('quick-apply-container') : null}
      backgroundColor={blue ? colors.NAVY_BLUE : null}
      marginLeftRight={size.width < MOBILE_BREAKPOINT ? 1 : 4}
    >
      <div
        style={{ position: size.width < MOBILE_BREAKPOINT ? 'sticky' : 'static', left: '0', right: '0', top: '0', height: '100%', overflow: 'auto' }}
      >
        {children}
      </div>
    </BaseModal>
  );
}

export default BasicForm;
